const mainSearchForm = {
  flights: "航班", // translated
  tours: "旅游", // translated
  hotel: "酒店", // translated
  hotels: "酒店", // translated
  services: "服务", // translated
  search: "搜索", // translated
  destination: "目的地", // translated
  includedServices: "包含的服务", // translated
  packageDuration: "套餐期限", // translated
  checkInOut: "入住/退房", // translated
  guests: "客人", // translated
  adults: "成年人", // translated
  children: "儿童", // translated
  child: "孩子", // translated
  age: "年龄", // translated
  yearsOld: "岁数", // translated
  rooms: "客房", // translated
  close: "关闭", // translated
  searchType: "搜索类型", // translated
  accommodation: "住宿", // translated
  transfers: "接送服务", // translated
  toursExperiences: "游览/体验", // translated
  nights: "夜晚", // translated
  days: "天", // translated
  packageType: "包装类型", // translated
  tourType: "旅游类型", // translated
  packages: "套餐", // translated
  cars: "汽车", // translated
  cruises: "游轮", // translated
  infantsInSeat: "婴儿坐在座位上", // translated
  infantsOnLap: "婴儿放在腿上", // translated
  airport: "飞机场", // translated
  passengers: "乘客", // translated
  departureReturn: "出发和返回日期", // translated
  origin: "起源", // translated
  roundTrip: "往返", // translated
  isRoundTrip: "是往返", // translated
  dream_packages: "梦想套餐", // translated
  partying: "聚会", // translated
  thingsToDo: "要做的事情", // translated
};

export default mainSearchForm;
